import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Music from './components/Music';
import Videos from './components/Videos';
import Tour from './components/Tour';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <Hero />
      <About />
      <Music />
      <Videos />
      <Tour />
      <Contact />
      <Footer />
    </div>
  );
}
